module.exports = __webpack_public_path__ + "static/media/Sejin Han.15bcdd69.png";